import React from 'react';
import PropTypes from 'prop-types';
import Video from 'commons-vehicle/Vehicle/components/VehicleBannerWithCarrousel/Video/Video.jsx';

const VideoWrapper = ({ videoURL }) => {
    const modalStyles = {
        overlay: {
            zIndex: 9999,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            height: '90%',
            padding: '0',
            overflow: 'visible',
            maxHeight: '500px',
            maxWidth: '890px',
            border: '0',
            backgroundColor: 'rgba(255, 255, 255, 1)',
        },
    };

    const modalOptions = {
        contentLabel: 'videoModal section dialog',
        style: modalStyles,
        shouldCloseOnOverlayClick: true,
    };

    return <Video videoURL={videoURL} modal={modalOptions} />;
};

VideoWrapper.propTypes = {
    videoURL: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
};

export default VideoWrapper;
